export default __webpack_public_path__ + "static/media/Reddit-Normal.20afb380.png";